// extracted by mini-css-extract-plugin
export default {"list":"Projects_list__wqvOc","proj":"Projects_proj__NUF1t"};